import React from 'react';
import { Box } from '@material-ui/core';
import { DateRange } from '@material-ui/icons';
import { Typography } from '../Typography';

interface LargeInfoProps {
    text: string;
    label: string;
    Icon: React.ComponentType;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const LargeInfo = ({ text, label, Icon }: LargeInfoProps) => (
    <Box display="flex" flexDirection="column" width='100%'>
        <Typography variant="overline">{label}</Typography>
        <Box display="flex" alignItems="center">
            <Icon />
            <Box ml={0.5} />
            <Typography variant="h5" noWrap>
                {text}
            </Typography>
        </Box>
    </Box>
);

export default LargeInfo;

export const LargeDateInfo = ({ text, label }: Pick<LargeInfoProps, 'text' | 'label'>) => (
    <LargeInfo
        text={text}
        label={label}
        Icon={DateRange}
    />
);
